export const TILE_SIZE = 35;
